import Button from "@pathwright/ui/src/components/button/Button"
import {
  getHumanExtensionList,
  getSignedFilestackURL,
  isFilePickerURL
} from "@pathwright/ui/src/components/filestack/utils"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import AudioPlayer from "lib/core/components/audio/AudioPlayer"
import FilePickerUpload from "lib/core/components/file-picker-upload/FilePickerUpload"
import React from "react"
import "./ContentMethodUpload.css"

// Use this component as a custom form input.
// See lib/core/components/form for spec.

const Previewer = ({ file }) => {
  if ((file != null ? file.url : undefined) && isFilePickerURL(file.url)) {
    file.src = getSignedFilestackURL(file.url) || null
  }

  return (
    <div className="ContentMethod__UploadPreview">
      <span>{file != null ? file.filename : undefined}</span>
      {(file != null ? file.src : undefined) ? (
        <AudioPlayer src={file.src} />
      ) : undefined}
    </div>
  )
}

const Uploader = ({ uploading, error, mediaType, pickFile }) => {
  const extensions = getHumanExtensionList(mediaType)
  return (
    <div className="ContentMethod__UploadButton">
      <Button
        onClick={pickFile}
        styleType="secondary"
        rounded={false}
        stretch={true}
      >
        <div className="ContentMethod__UploadIcon">
          <Pathicon icon={mediaType} />
        </div>
        {`\
Upload an `}
        {mediaType} file ({extensions}
        {`)\
`}
      </Button>
    </div>
  )
}

class ContentMethodUpload extends React.Component {
  constructor(...args) {
    super(...args)
    this.handleFileUploaded = this.handleFileUploaded.bind(this)
  }

  handleFileUploaded(file) {
    const value = _.extend({}, this.props.value, file)
    return typeof this.props.onChange === "function"
      ? this.props.onChange(value, this.props)
      : undefined
  }

  render() {
    return (
      <div className="ContentMethod__Upload">
        <FilePickerUpload
          file={this.props.value}
          mediaType={this.props.mediaType}
          previewer={Previewer}
          uploader={Uploader}
          onFileUploaded={this.handleFileUploaded}
        />
      </div>
    )
  }
}

ContentMethodUpload.displayName = "ContentMethodUpload"

ContentMethodUpload.defaultProps = { mediaType: "audio" }

export default ContentMethodUpload
